export default __webpack_public_path__ + "static/player-lounge-banner-cd832285de2bc27cfa96a99552588dfb.png";